import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en, { namespaces, defaultNS } from './en';
import fr from './fr';
import es from './es';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
import 'dayjs/locale/es'; // Import Spanish locale
import { Languages, TranslatedLanguage } from '../../interface';

export const resources = {
  en,
  fr,
  es,
} as const;

i18n.use(LanguageDetector).init();
i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  ns: namespaces,
  defaultNS,
  interpolation: { escapeValue: false },
  resources,
});

export const getLanguage = (): TranslatedLanguage => {
  if (i18n.language === 'fr') return TranslatedLanguage.fr;
  if (i18n.language === 'es') return TranslatedLanguage.es;
  return TranslatedLanguage.en;
};

export const setLanguage = (language: Languages) => {
  const languageI18n = {
    ENGLISH: TranslatedLanguage.en,
    FRENCH: TranslatedLanguage.fr,
    SPANISH: TranslatedLanguage.es,
  };
  i18n.changeLanguage(languageI18n[language]);
};

export default i18n;
